import PageWrapperActionsUnderTitle from './PageWrapperTwoTitleLayers'

export default PageWrapperActionsUnderTitle
